import {
  CcfDoubleArrowIcon,
  CcfTypography,
  CcfAccordion,
  CcfAccordionSummary,
  CcfAccordionDetails,
  CcfHyperlinkIcon,
  CcfTooltip,
  CcfUpArrowIcon,
} from '@nice-ccf/ui-controls';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { createStyles, makeStyles } from '@mui/styles';
import { useTranslator, CcfBox } from '@nice-ccf/ui-controls';
import {
  Button,
  CardActionArea,
  CardContent,
  Direction,
  IconButton,
  Link,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';
import {
  activeContactSelector,
  getApplicationDirection,
} from '@nice-ccf/ui-components';
import CheckIcon from '@mui/icons-material/Check';

import styles from './ccf-all-interaction.module.scss';
import customerCardStyles from '../ccf-customer-card.styles';

const useStyles = makeStyles((theme) =>
  createStyles({
    inputRoot: {
      font: 'normal normal normal 13px/30px Open Sans !important',
      letterSpacing: '0px',
      color: '#33333 !important',
      lineHeight: '18px',
      '&. MuiInputBase-root': {
        font: 'normal normal normal 13px/30px Open Sans !important',
        letterSpacing: '0px',
        webkitTextFillColor: '#333333 !important',
        lineHeight: '18px',
      },
    },
    input: {
      color: '#333333 !important',
    },
    disabled: {
      '&.Mui-disabled': {
        '-webkit-text-fill-color': '#333333 !important',
        border: 'none !important',
      },
    },
  })
);

/* eslint-disable-next-line */
export interface CcfAllInteractionProps {}

/**
 * CcfCustomerCard used to disply active contact customer details in the AppSpace
 * @param props --? - CcfCustomerCardProps
 * @example -- <CcfCustomerCard />
 */
export function CcfAllInteraction(props: CcfAllInteractionProps) {
  const appDirection: Direction = useSelector(getApplicationDirection);
  const activeContact = useSelector(activeContactSelector);
  const interaction = activeContact?.recentInteraction;

  const [expanded, setExpanded] = useState('allinteraction');
  const [randomNumbers, setRandomNumbers]: any = useState([]);

  const [allInteractionExpanded, setAllInteractionExpanded] = useState(Array);
  const [copyIconClick, setCopyIconClick]: any = useState([
    { id: 0, linkIcon: false },
    { id: 1, linkIcon: false },
    { id: 2, linkIcon: false },
  ]);

  const theme = useTheme();
  const stylesAccordion = customerCardStyles(theme);

  const ltrRtlActive = appDirection === 'rtl' ? 'rtlActive' : 'ltrActive';

  /**
   * handleChange Event - used to expand and collapse of channels accordion
   * @param panel- 'contacthistory'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - handleChange(panel)
   */
  const handleChange = (panel: string) => {
    setExpanded(expanded === 'allinteraction' ? '' : panel);
  };

   /**
   * handleChange Event - used to expand and collapse of channels accordion
   * @param id- 'id of interaction'
   * @param newExpanded - boolean
   * @example - handleInteractionChange(panel)
   */
  const handleInteractionChange = (id: number) => {
    const updatedExpandedItems = allInteractionExpanded.includes(id)
      ? allInteractionExpanded.filter((item) => item !== id)
      : [...allInteractionExpanded, id];
    setAllInteractionExpanded(updatedExpandedItems);
  };
  const [translate] = useTranslator();

  /**
   * function to generate UUID
   * 
   * @param newExpanded - boolean
   * @example - generateUUID()
   */
  function generateUUID() {
    return new Array(2)
      .fill(0)
      .map(() =>
        Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(20)
      )
      .join('')
      .substring(0, 22);
  }

  useEffect(() => {
    const id1 = generateUUID();
    const id2 = generateUUID();
    const id3 = generateUUID();
    const caseId1 = Math.floor(Math.random() * (999 - 100 + 1)) + 100;
    const caseId2 = Math.floor(Math.random() * (999 - 100 + 1)) + 100;

    const caseId3 = Math.floor(Math.random() * (999 - 100 + 1)) + 100;

    setRandomNumbers([
      { id: id1, caseId: caseId1 },
      { id: id2, caseId: caseId2 },
      { id: id3, caseId: caseId3 },
    ]);
  }, []);

   /**
   * function to toggke icon
   * 
   * @param newExpanded - boolean
   * @example -  toggleIcon()
   */
  const toggleIcon = (index: any) => {
    const newPlayIcons = [...copyIconClick];
    newPlayIcons[index] = !newPlayIcons[index];
    setCopyIconClick(newPlayIcons);
  };
  return (
    <section className={ltrRtlActive}>
      <CcfAccordion
        square
        expanded={expanded === 'allinteraction'}
        sx={stylesAccordion.accordionContainer}
      >
        <CcfAccordionSummary
          expandIcon={
            <CcfDoubleArrowIcon
              onClick={() => handleChange('allinteraction')}
              sx={stylesAccordion.expandedIcon}
            />
          }
          aria-controls="all-interactions-header"
          sx={
            expanded === 'allinteraction'
              ? stylesAccordion.accordionHeaderExpand
              : stylesAccordion.ccfAppSpaceAccordionHeader
          }
          id="agent_appSpace_relatedInteraction"
        >
          <CcfBox className={styles.contactChannelInfo}>
            <CcfBox component="div" className={styles.titleRow}>
              <CcfTypography className={styles.title}>
                {' '}
                Related Interactions
              </CcfTypography>
              {expanded === 'allinteraction' && (
                <CcfTooltip
                  title="Refresh CRM records"
                  arrow
                  placement="top"
                  styles={{
                    ccfTooltipArrow: {
                      color: 'white',
                    },
                    ccfTooltip: {
                      borderRadius: '6px',
                      backgroundColor: 'white',
                      boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 30%)',
                      color: 'black',
                    },
                  }}
                >
                  <IconButton
                    style={{
                      backgroundColor: 'var(--color-blue)',
                      borderRadius: '3px',
                      padding: '0px 11px',
                    }}
                    id={`agent_appSpace_relatedInteraction_refresh`}
                  >
                    <CcfTypography style={{ color: '#ffffff' }}>
                      Refresh
                    </CcfTypography>
                  </IconButton>
                </CcfTooltip>
              )}
            </CcfBox>
          </CcfBox>
        </CcfAccordionSummary>
        <CcfAccordionDetails>
          <section className={styles.interactionContainer}>
            {interaction.map((x: any, i: any) => (
              <CcfAccordion
                square
                style={{ marginBottom: '15px', backgroundColor: '#f5f8fa' }}
                expanded={allInteractionExpanded.includes(x.id)}
                onChange={() => handleInteractionChange(x.id)}
              >
                <CcfAccordionSummary
                  expandIcon={
                    <CcfUpArrowIcon sx={stylesAccordion.expandedIcon} />
                  }
                  aria-controls="detail-content"
                  id={`agent_appSpace_relatedInteraction_${x.customerName}`}
                  sx={{ margin: '0px', minHeight: '25px' }}
                  // sx={simStyles.accordionHeader}
                  style={{ maxHeight: '40px' }}
                >
                  <Typography className={styles.customerName}>
                    {x.customerName}
                  </Typography>
                </CcfAccordionSummary>
                <CcfAccordionDetails classes={{ root: styles.root }}>
                  <CardActionArea key={'index'}>
                    <CardContent style={{ padding: '0px' }}>
                      {x.loyaltyStatus && (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '2px',
                          }}
                        >
                          {' '}
                          <CcfTypography className={styles.loyaltyStatus}>{`${
                            x.loyaltyStatus.split(',')[0] || ''
                          }  : `}</CcfTypography>{' '}
                          <CcfTypography>{`${
                            x.loyaltyStatus.split(',')[1] || ''
                          }`}</CcfTypography>
                        </div>
                      )}

                      {x.loyaltyPoints && (
                        <div className={styles.pointsGrid}>
                          <CcfTypography className={styles.loyaltyStatus}>{`${
                            x.loyaltyPoints.split(',')[0] || ''
                          } : `}</CcfTypography>{' '}
                          <CcfTypography style={{ paddingTop: '1px' }}>{`${
                            x.loyaltyPoints.split(',')[1] || ''
                          }`}</CcfTypography>
                        </div>
                      )}

                      <Paper className={styles.parentPaper}>
                        <div className={styles.paperGrid}>
                          <CcfTypography style={{ fontWeight: '600' }}>
                            Case #{randomNumbers[i]?.caseId}
                          </CcfTypography>
                          <div style={{ display: 'flex', gap: '5px' }}>
                            <CcfBox
                              className={
                                copyIconClick[i]
                                  ? styles.linkIcon
                                  : styles.greenStatus
                              }
                            >
                              <IconButton
                                style={{ padding: '0px' }}
                                onClick={() => {
                                  toggleIcon(i);
                                }}
                                id={`agent_appSpace_relatedInteraction_hyperLink`}
                              >
                                {copyIconClick[i] ? (
                                  <CcfHyperlinkIcon
                                    fillColor="#ffffff"
                                    className={styles.articleIcon}
                                  />
                                ) : (
                                  <CheckIcon className={styles.tickIcon} />
                                )}
                              </IconButton>{' '}
                            </CcfBox>

                            <div
                              style={{ height: '25px' }}
                              id={`agent_appSpace_relatedInteraction_nowContact`}
                            >
                              <CcfTooltip
                                title="ServiceNow 2 Contact"
                                arrow
                                placement="top"
                                styles={{
                                  ccfTooltipArrow: {
                                    color: 'white',
                                  },
                                  ccfTooltip: {
                                    borderRadius: '6px',
                                    backgroundColor: 'white',
                                    boxShadow:
                                      '0px 5px 15px 0px rgb(0 0 0 / 30%)',
                                    color: 'black',
                                  },
                                }}
                              >
                                <div>
                                  <Link
                                    target="_blank"
                                    href={x.crmUrl}
                                    underline="none"
                                    rel="noreferrer"
                                  >
                                    <img
                                      src={x.crmIcon}
                                      style={{ width: '70px', height: '25px' }}
                                      alt={'nowCase'}
                                    />
                                  </Link>
                                </div>
                              </CcfTooltip>
                            </div>
                          </div>
                        </div>
                        <CcfTypography>
                          Id : {randomNumbers[i]?.id}
                        </CcfTypography>
                      </Paper>
                    </CardContent>
                  </CardActionArea>
                </CcfAccordionDetails>
              </CcfAccordion>
            ))}
          </section>
        </CcfAccordionDetails>
      </CcfAccordion>
    </section>
  );
}

export default CcfAllInteraction;
